import axios from 'axios';

/**
 * @typedef {object} Term
 * @property {string}   id
 * @property {string}   name
 * @property {string}   type
 * @property {number[]} paths
 * @property {string}   startDate
 * @property {string}   endDate
 * @property {object[]} instances
 */

export default {
    get(context, courseId, raw) {
        var options = {
            url: window.apiUrl + '/terms',
          //  headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getSupervisorTerms(context) {
        var options = {
            url: window.apiUrl + '/supervisor-terms',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    /**
     * @async
     * @param {string} id
     * @returns {Term}
     */
    getTerm(id) {
      // TODO: use server-side route like /terms/:id instead of just filtering
      // through all terms
      return module.exports.default.get().then(response => {
        if (!response.data.success) {
          throw new Error(response.data.error);
        }
        const term = response.data.terms.find(t => t.id == id);
        if (!term) {
          throw new Error('term not found');
        }
        return term;
      });
    },

    /**
     * Gets terms for the currently logged in user.
     * @async
     * @returns {Term[]}
     */
    getMyTerms() {
      return module.exports.default.get().then(response => {
        if (!response.data.success) {
          throw new Error(response.data.error);
        }
        return response.data.terms;
      });
    },

    /**
     * Gets all the term types currently in use ('foundation', etc).
     * @async
     * @returns {string[]}
     */
    getTermTypes() {
      return module.exports.default.get().then(response => {
        if (!response.data.success) {
          throw new Error(response.data.error);
        }
        const types = new Set();
        response.data.terms.forEach(term => {
          types.add(term.type);
        });
        return Array.from(types);
      });
    },
};



// WEBPACK FOOTER //
// ./src/services/terms/index.js